<div class="flex flex-col">
  <button
    tuiIconButton
    appearance="primary"
    size="s"
    class="ml-auto relative top-8 mr-6"
    [icon]="close"
    (click)="closeChat()"
  ></button>
  <ng-template #close>
    <svg-icon [src]="'/assets/img/ic-close.svg'"></svg-icon>
  </ng-template>
  <iframe
    class="rounded-md"
    src="https://guest.gr.chat/?c=a78fde8e840d3357267ea29a61db790f6e89008391e5a9172495185d2009fe1dbba68fe00926adadc8ea48322720d73865ba7d5640d58de09c0b56c464b9d38a"
  >
  </iframe>
</div>
